import { render, staticRenderFns } from "./grasimi.vue?vue&type=template&id=ed4b46ce&"
import script from "./grasimi.vue?vue&type=script&lang=js&"
export * from "./grasimi.vue?vue&type=script&lang=js&"
import style0 from "./grasimi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports